export interface RuntimeEnvironmentConfig {
  production: boolean;
  ssoBase: string;
  friendlyName: string;
  showQaBanner: boolean;
  useNewDesign: boolean;
  /** Host suffixes the chatbot may link to (served from ChatBot:AllowedLinkHosts). */
  chatLinkHosts?: string[];
  assessorSiteUrl: string;
  portalApiUrl: string;
}

declare global {
  var __APP_CONFIG__: Partial<RuntimeEnvironmentConfig> | undefined;

  interface Window {
    __APP_CONFIG__?: Partial<RuntimeEnvironmentConfig>;
  }
}

const toBoolean = (value: unknown, fallback: boolean): boolean => {
  if (typeof value === 'boolean') {
    return value;
  }

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    return normalized === 'true';
  }

  return fallback;
};

const toStringOrFallback = (value: unknown, fallback: string): string => {
  return typeof value === 'string' && value.trim().length > 0 ? value : fallback;
};

export const resolveRuntimeEnvironment = (defaults: RuntimeEnvironmentConfig): RuntimeEnvironmentConfig => {
  const runtime = globalThis.__APP_CONFIG__;
  if (!runtime) {
    return defaults;
  }

  return {
    production: toBoolean(runtime.production, defaults.production),
    ssoBase: toStringOrFallback(runtime.ssoBase, defaults.ssoBase),
    friendlyName: toStringOrFallback(runtime.friendlyName, defaults.friendlyName),
    showQaBanner: toBoolean(runtime.showQaBanner, defaults.showQaBanner),
    useNewDesign: toBoolean(runtime.useNewDesign, defaults.useNewDesign),
    chatLinkHosts: Array.isArray(runtime.chatLinkHosts)
      ? runtime.chatLinkHosts.filter((h): h is string => typeof h === 'string')
      : defaults.chatLinkHosts,
    assessorSiteUrl: toStringOrFallback(runtime.assessorSiteUrl, defaults.assessorSiteUrl),
    portalApiUrl: toStringOrFallback(runtime.portalApiUrl, defaults.portalApiUrl),
  };
};
